import styles from './voucher.module.scss'
import React, { useEffect, useState, useRef } from 'react'
import { compare, formatCash } from 'utils'
import moment from 'moment'

import { Input, Switch, Row, Col, Table, notification, Space } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

//components
import TitlePage from 'components/title-page'
import FilterDate from 'components/filter-date'
//apis
import { getVouchers, deleteVoucher, updateVoucher } from 'apis/voucher'

export default function Voucher() {
  const typingTimeoutRef = useRef(null)

  const [countVoucher, setCountVoucher] = useState(0)
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20 })
  const [vouchers, setVouchers] = useState([])
  const [loading, setLoading] = useState(false)
  const [valueSearch, setValueSearch] = useState('')

  const columnsVoucher = [
    {
      title: 'STT',
      render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
      width: 50,
    },
    {
      title: 'Mã voucher',
      sorter: (a, b) => compare(a, b, 'code'),
      dataIndex: 'code',
    },
    {
      title: 'Giá trị hiện tại',
      sorter: (a, b) => compare(a, b, 'value_current'),
      render: (data, record) => <div>{record.value_current || 0}</div>,
    },
    {
      title: 'Giá trị đã mua',
      dataIndex: 'final_cost',
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phone',
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      title: 'Thời gian mua',
      dataIndex: 'create_date',
      render: (data, record) => moment(record.create_date).format('DD/MM/YYYY, H:mm:ss'),
    },
    {
      title: 'Hành động',
      render(data, record) {
        return (
          <Space>
            <Switch
              checked={data}
              onChange={(e) => _updateVoucher(record.order_id, { is_active: e })}
            />
            {/* <Popconfirm
              onConfirm={() => _deleteVoucher(record.voucher_id)}
              title="Bạn có muốn xóa voucher này không?"
            >
              <Button type="primary" icon={<DeleteOutlined />} danger />
            </Popconfirm> */}
          </Space>
        )
      },
    },
  ]

  const _updateVoucher = async (id, body) => {
    try {
      const res = await updateVoucher(id, body)
      if (res.status === 200) {
        _getVouchers()
        notification.success({ message: 'Cập nhật chương trình khuyến mãi thành công' })
      } else
        notification.error({
          message:
            res.data.message || 'Cập nhật chương trình khuyến mãi thất bại, vui lòng thử lại',
        })
    } catch (e) {
      console.log(e)
    }
  }

  const onSearch = (e) => {
    setValueSearch(e.target.value)

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      const value = e.target.value
      if (value) paramsFilter.code = value
      else delete paramsFilter.code
      setParamsFilter({ ...paramsFilter, page: 1 })
    }, 750)
  }

  const onFilters = (attribute = '', value = '') => {
    if (value) paramsFilter[attribute] = value
    else delete paramsFilter[attribute]
    setParamsFilter({ ...paramsFilter })
  }

  const _getVouchers = async () => {
    try {
      setLoading(true)
      const res = await getVouchers({ ...paramsFilter, _creator: true, is_gift: false })
      if (res.status === 200) {
        setVouchers(res.data.data)
        setCountVoucher(res.data.count)
      }
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const _deleteVoucher = async (id) => {
    try {
      setLoading(true)
      const res = await deleteVoucher([id])
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Xóa voucher thành công' })
          _getVouchers()
        } else notification.error({ message: 'Xóa voucher thất bại, vui lòng thử lại' })
      } else notification.error({ message: 'Xóa voucher thất bại, vui lòng thử lại' })
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    _getVouchers()
  }, [paramsFilter])

  return (
    <>
      <div className={`${styles['voucher_manager']} ${styles['card']}`}>
        <TitlePage title="QUẢN LÝ VOUCHER ĐÃ MUA" />

        <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
          <Col xs={24} sm={24} md={24} lg={6} xl={6}>
            <Input
              prefix={<SearchOutlined />}
              size="large"
              placeholder="Tìm kiếm voucher"
              onChange={onSearch}
              allowClear
              value={valueSearch}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={6} xl={6}>
            <FilterDate
              size="large"
              paramsFilter={paramsFilter}
              setParamsFilter={setParamsFilter}
            />
          </Col>
        </Row>

        <div
          style={{
            width: '100%',
            marginTop: '1rem',
            border: '1px solid rgb(243, 234, 234)',
          }}
        >
          <Table
            size="small"
            rowKey="voucher_id"
            loading={loading}
            pagination={{
              position: ['bottomLeft'],
              current: paramsFilter.page,
              defaultPageSize: 20,
              pageSizeOptions: [20, 30, 40, 50, 60, 70, 80, 90, 100],
              showQuickJumper: true,
              onChange: (page, pageSize) =>
                setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
              total: countVoucher,
            }}
            columns={columnsVoucher}
            dataSource={vouchers}
            scroll={{ y: 500 }}
          />
        </div>
      </div>
    </>
  )
}
